import { ApiError, fetchWithAuth } from "@entities/user-tokens";

/**
 * 規定の写し。組立が完了したタスクの内部用 PPTX から切り出したもので、上書きはこれに対する
 * 差分である。まだ組立を通っていないタスクでは `null` になる。
 */
export type TaskPromptBaseline = {
    version: number;
    fingerprint: string;
    assignments: { [id: string]: { instruction?: string; skip?: boolean } };
};

/**
 * タスクの規定の写しを読む。写しが無ければ `null`。
 *
 * 再生成で手元の調整を差分として送るために使う。写しは元タスクの内部用 PPTX そのものなので、
 * アドインが開いているファイルと同じ本文が入っている。**差分を取る相手はこれである。**
 */
export async function getTaskBaseline(
    projectId: string,
    taskId: string
): Promise<TaskPromptBaseline | null> {
    const res = await fetchWithAuth(
        `/generation-tasks/${encodeURIComponent(taskId)}/baseline` +
            `?projectId=${encodeURIComponent(projectId)}`,
        { headers: { Accept: "application/json" } }
    );
    if (!res.ok) throw await ApiError.fromResponse(res, "規定の写しを取得できませんでした");
    const body = (await res.json()) as { baseline: TaskPromptBaseline | null };
    return body.baseline ?? null;
}
